import MessageButton from './message_button';
import {PRIORITY_LEVEL} from '../../services/overlay_manager/overlay_manager_levels';
import BaseModelComponent from '../../base/base_model_component';
import _ from '../../utils/underscore';
import DOM from '../../utils/dom';
import { IMessageOptions } from '../../services/message_manager/message_manager_service_interface';


/**
 * @property {string} type - predefined message type
 * @property {string} title - title message
 * @property {string} text - text message
 * @property {string} footerText - footer text message
 * @property {string} imgClass - the class contains image url that should be displayed
 * @property {boolean} hasImage - define if MDP should be opened with image placement
 * @property {boolean} hasDefaultButton - define if MDP should create the single closable button automatically when there are not buttons provided
 * @property {number} priority - the message priority
 * @property {MessageButton[]|{name:string,callback:function}[]} buttons - array of string that represent button action
 * @param {MessageOptions} params
 * @throws {Error} text must be define if not throw 'must contain text in message';
 */


/**
 * Message entity
 */

export default class MessageModel extends BaseModelComponent {
    static isMessage(msg: any) {
        return 'buttons' in msg &&
            'title' in msg &&
            'text' in msg &&
            'type' in msg &&
            'priority' in msg &&
            'buttons' in msg &&
            'timeStamp' in msg;
    }
    static CLASS = 'MessageModel';

    /**
     *
     * @param params
     */
    init(params: IMessageOptions) {
        this._initModel(params);
    }

    /**
     * Set the priority of the message, lower is higher priority
     */
    priority: number;

    /**
     * If set to true, will not escape title and text parameters
     */
    html: boolean = false;

    /**
     * The title of the message
     */
    title: string;

    /**
     * The Text of the message
     */
    text: string;

    /**
     * The footer text of the message
     */
    footerText: string;

    /**
     * The type of the message
     */
    type: string;

    /**
     * define whether there is a close button
     */
    closeButton: boolean;

    /**
     * define whether there is default button exisst
     */
    hasButton: boolean;

    contentEl: HTMLElement;

    footerContentEl: HTMLElement;

    contentAlign: string;

    /**
     * @typedef {Object} MessageOptions - message constructor options
     * @property {string} type - predefined message type
     * @property {string} title - title message
     * @property {string} text - text message
     * @property {string} footerText - footer text message
     * @property {string} imgClass - the class contains image url that should be displayed
     * @property {boolean} hasImage - define if MDP should be opened with image placement
     * @property {boolean} hasDefaultButton - define if MDP should create the single closable button automatically when there are not buttons provided
     * @property {number} priority - the message priority
     * @property {MessageButton[]|{name:string,callback:function}[]} buttons - array of string that represent button action
     * @param {MessageOptions} params
     * @throws {Error} text must be define if not throw 'must contain text in message';
     */
    _initModel(params: IMessageOptions) {
        const defaultOptions: IMessageOptions = {
            type: '',
            title: null,
            hasTitle: true,
            buttonPosition: '',
            closeButton: true,
            text: '',
            footerText: '',
            contentAlign: '',
            contentEl: null,
            footerContentEl: null,
            imgClass: '',
            hasImage: false,
            priority: PRIORITY_LEVEL.MESSAGE,
            hasDefaultButton: true,
            forceAnalytic: false,
            ignoreMobile: false,
            customCSSClassList: [],
            titleElements: [],
            closeCallback: () => {},
            openCallback: () => {},
            footerClickedCallback: () => {},
            btnCloseCallback: () => {}
        };

        const options: IMessageOptions = Object.assign({}, defaultOptions, params);

        // fix title
        options.title = (!options.title || options.title === '') ? '&nbsp;' : options.title;

        let buttons: MessageButton[] = [];

        // create default button or use provided buttons only if hasButton option is true
        if (options.buttons && _.isArray(options.buttons) && options.buttons.length > 0) {
            options.buttons.forEach((button) => {
                buttons.push(new MessageButton(button));
            });
        } else if (true === options.hasDefaultButton) {
            buttons = [new MessageButton({})];
        }
        options.buttons = buttons;

        //TODO: move each defaultOptions members as class members!!!
        //this is not a good practise
        Object.keys(options).forEach((key) => {
            //if (!this[key]) {
                this[key] = options[key];
            //}
        });

        this._createContentEl();
        this._createFooterContentEl();
    }


    /**
     * Create contet element and inject to it if contentEl was not passed
     * @private
     */
    _createContentEl() {
        if (!this.contentEl) {
            this.contentEl = !_.isElement(this.text) ? DOM.createElement('div', this.text) : this.text as unknown as HTMLElement;
        }
    }

    /**
     * Create footer contet element and inject to it if footerContentEl was not passed
     * @private
     */
    _createFooterContentEl() {
        if (this.footerText) {
            if (!this.footerContentEl) {
                this.footerContentEl = !_.isElement(this.footerText) ? DOM.createElement('div', this.footerText) : this.footerText as unknown as HTMLElement;
            }
        }
    }
}
